import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Stack,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import api from "../../../services/api";
import StoreLocationFormModal from "./StoreLocationFormModal";

const formatHours = (customHours = {}) => {
  return Object.entries(customHours)
    .map(([day, { open, close }]) => {
      return `${day.toUpperCase()}: ${open || "Closed"} - ${close || "Closed"}`;
    })
    .join(", ");
};

const AdminStoreLocationsPage = () => {
  const [locations, setLocations] = useState([]);
  const [editData, setEditData] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const fetchLocations = async () => {
    try {
      const { data } = await api.get("/admin/stores");
      setLocations(data);
    } catch (error) {
      console.error("Failed to fetch locations:", error);
    }
  };

  useEffect(() => {
    fetchLocations();
  }, []);

  const handleDelete = async (id) => {
    await api.delete(`/admin/stores/${id}`);
    fetchLocations();
  };

  return (
    <>
      <Box>
        <Box display="flex" justifyContent="space-between" mb={3}>
          <Typography variant="h5" fontWeight="bold">
            Store Locations
          </Typography>
          <Button
            startIcon={<AddIcon />}
            variant="contained"
            onClick={() => {
              setEditData(null);
              setModalOpen(true);
            }}>
            Add Store
          </Button>
        </Box>

        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Address</TableCell>
              <TableCell>City</TableCell>
              <TableCell>Contact</TableCell>
              <TableCell>Coordinates</TableCell>
              <TableCell>Hours</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {locations.map((loc) => (
              <TableRow key={loc._id}>
                <TableCell>{loc.name}</TableCell>
                <TableCell>
                  {loc.address}
                  <br />
                  {loc.province}, {loc.country}
                </TableCell>
                <TableCell>{loc.city}</TableCell>
                <TableCell>
                  <Stack spacing={0.5}>
                    <Typography variant="body2">{loc.phone}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {loc.email}
                    </Typography>
                  </Stack>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {loc.coordinates?.lat}, {loc.coordinates?.lng}
                  </Typography>
                </TableCell>
                <TableCell sx={{ maxWidth: 240 }}>
                  <Typography variant="caption" color="text.secondary">
                    {formatHours(loc.customHours)}
                  </Typography>
                </TableCell>
                <TableCell>
                  <IconButton
                    onClick={() => {
                      setEditData(loc);
                      setModalOpen(true);
                    }}>
                    <EditIcon />
                  </IconButton>
                  <IconButton onClick={() => handleDelete(loc._id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>

      {/* ✅ Only mount modal when open is true */}
      {modalOpen && (
        <StoreLocationFormModal
          open={modalOpen}
          onClose={() => {
            setModalOpen(false);
            setEditData(null);
          }}
          editData={editData}
          onSuccess={fetchLocations}
        />
      )}
    </>
  );
};

export default AdminStoreLocationsPage;
